import React from "react";
import styles from "./EditModeNotice.module.css";
import { tWithKeyAttr as t } from "../../i18nHelper";
const EditModeNotice = () => {
  return <div  className={styles.notice}>{t("YOU_ARE_NOW_IN_EDITING_MODE._DOUBLE_CLICK_ON_TEXT_TO_OPEN_THE_EDITING_OPTION")}</div>;
};

export default EditModeNotice;
